export function getGA4ClientId() {
  const cookie = {}
  document.cookie.split(';').forEach(function (el) {
    const splitCookie = el.split('=')
    const key = splitCookie[0].trim()
    const value = splitCookie[1]
    cookie[key] = value
  })

  return cookie._ga ? cookie._ga.slice(6) : null
}
